"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const Icon_1 = __importDefault(require("./Icon"));
function ZipIcon(props) {
    return (react_1.default.createElement(Icon_1.default, Object.assign({}, props),
        react_1.default.createElement("rect", { fill: "none", width: "24", height: "24" }),
        react_1.default.createElement("rect", { fill: "none", width: "24", height: "24" }),
        react_1.default.createElement("path", { strokeWidth: "0", d: "m14.751,1.768h-7.921c-1.441,0-2.614,1.146-2.614,2.555v15.354c0,1.409,1.173,2.556,2.614,2.556h10.341c1.441,0,2.614-1.146,2.614-2.556V6.759L14.751,1.768Zm2.42,18.765H6.829c-.504,0-.914-.385-.914-.856V4.323c0-.472.41-.855.914-.855h6.933v3.229c0,.517.419.937.937.937h3.386v12.043c0,.472-.41.856-.914.856Z" }),
        react_1.default.createElement("rect", { strokeWidth: "0", x: "11.491", y: "15.148", width: "3.927", height: "1.699" }),
        react_1.default.createElement("rect", { strokeWidth: "0", x: "9.224", y: "12.832", width: "3.927", height: "1.699" }),
        react_1.default.createElement("rect", { strokeWidth: "0", x: "9.224", y: "17.465", width: "3.927", height: "1.699" }),
        react_1.default.createElement("rect", { strokeWidth: "0", x: "11.491", y: "10.514", width: "3.927", height: "1.699" }),
        react_1.default.createElement("rect", { strokeWidth: "0", x: "9.224", y: "8.198", width: "3.927", height: "1.699" })));
}
exports.default = ZipIcon;
